//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

const Report = () => {
  const { state, dispatch } = useContext(Context);
  const { handleResponse, handleError } = HandleApiResponse();

  async function getCostCenter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/reports/cost-center?month=${values.month}&columns=${values.columns}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function RollForwardAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/roll-forward`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function burnAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/burn`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function earnAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/earn`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function pointsBalanceAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/points-balance`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function memberIDStatusAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/member-id-status`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function customerStatusAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/customer-status`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function shiptoSummaryAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/shipto-summary`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function searchLoyaltyAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/reports/get-loyalty?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function loyaltyDetailsAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/loyalty-details`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function memberRewardsAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/loyalty-rewards`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function progressStatus(response) {
    const reader = response.body.getReader();
    const contentLength = +response.headers.get("Content-Length"); // get total length
    let receivedLength = 0; // received that many bytes at the moment
    let previousValue;
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      receivedLength += value.length;
      let progress = Math.round((receivedLength / contentLength) * 100);
      if (previousValue !== progress) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: progress });
      }
      previousValue = progress;
    }
  }
  async function CiprianReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/ciprian`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }
  async function DeactivationSummaryReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/deactivationsummary`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }
  async function YetToBeDeactivationReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/yettobedeactivation`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function annualRewardStatmentAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/reports/annual-reward-statement`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }
  async function promoList(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/reports/get-promo?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function promoEarnAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/promoearn`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }
  async function signatureStatementAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/signature-statement-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function fscSummaryReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/fsc-summary-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function welcomeEmailReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/welcome-email-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function monthlypointsexpiration(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/monthly_points_expiration`, obj);
      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } 
    catch (err) {}
  }

  async function getyearmonthAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/kpi-reports/monthyear`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }
  async function PBIReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/PBI-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }
  

  async function SignatureBenefitReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/signature-benefit-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function marketoMailchimpReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/marketo-or-mailchimp-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function WeeklyConsentReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/weekly-consent-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function SignatureAuditAPI(values) {
    try {
      console.log("reportjs",SignatureAuditAPI)
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/SignatureAudit-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function DormantReaminderMailTrackerAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/dormant-remainder-mail-tracker-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function ThriveReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/thrive-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }
  
  async function StartupAuditAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/StartupAudit-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function StartupBenefitReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/startup_benefit_report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function UnlockEarnReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/unlock-earn-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }


  async function SignatureRetentionAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/signature-churn`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function UnlockTrendAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/unlock-trend`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }
  async function UnlockOriginReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/unlock-origin-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }
  async function unlockShiptoEarnAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/unlock-shipto-earn`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  async function growthBonusMailTrackerReport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/reports/growth-bonus-mail-tracker-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) { }
  }

  return {
    getCostCenter,
    RollForwardAPI,
    burnAPI,
    earnAPI,
    pointsBalanceAPI,
    memberIDStatusAPI,
    customerStatusAPI,
    shiptoSummaryAPI,
    searchLoyaltyAPI,
    loyaltyDetailsAPI,
    memberRewardsAPI,
    CiprianReportAPI,
    DeactivationSummaryReportAPI,
    YetToBeDeactivationReportAPI,
    annualRewardStatmentAPI,
    promoList,
    promoEarnAPI,
    signatureStatementAPI,
    fscSummaryReportAPI,
    welcomeEmailReportAPI,
    monthlypointsexpiration,
    getyearmonthAPI,
    PBIReportAPI,
    SignatureBenefitReportAPI,
    marketoMailchimpReportAPI,
    WeeklyConsentReportAPI,
    SignatureAuditAPI,
    DormantReaminderMailTrackerAPI,
    ThriveReportAPI,
    StartupAuditAPI,
    StartupBenefitReportAPI,
    UnlockEarnReportAPI,
    SignatureRetentionAPI,
    UnlockTrendAPI,
    UnlockOriginReportAPI,
    unlockShiptoEarnAPI,
    growthBonusMailTrackerReport
  };
};
export default Report;
